// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.category-section {
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.2s ease;
}

.category-trigger {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background: none;
    border: none;
    cursor: pointer;
    text-align: left;
    transition: background-color 0.2s ease;
}

.category-trigger:hover {
    background: #f9fafb;
}

.category-info {
    display: flex;
    align-items: center;
    gap: 8px;
}

.category-icon {
    font-size: 16px;
}

.category-title {
    font-size: 14px;
    font-weight: 500;
    color: #1f2937;
}

.chevron {
    width: 16px;
    height: 16px;
    color: #6b7280;
    transition: transform 0.2s ease;
}

.chevron-up {
    transform: rotate(180deg);
}

.chevron-down {
    transform: rotate(0deg);
}

.category-content {
    transition: all 0.2s ease;
    overflow: hidden;
}

.content-closed {
    max-height: 0;
    opacity: 0;
}

.content-open {
    opacity: 1;
}

.questions-list {
    padding: 8px 12px 12px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    background: #fafbfc;
}

.question-button {
    width: 100%;
    text-align: left;
    padding: 8px 12px;
    background: #f0f2f5;
    border: 1px solid transparent;
    border-radius: 6px;
    cursor: pointer;
    font-size: 13px;
    color: #374151;
    line-height: 1.4;
    transition: all 0.2s ease;
}

.question-button:hover {
    background: #dbeafe;
    border-color: #e5e7eb;
    color: #1d4ed8;
    transform: translateY(-1px);
}

.question-button:active {
    transform: translateY(0);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/CategorySection.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B","sourcesContent":[".category-section {\r\n    background: white;\r\n    border: 1px solid #e5e7eb;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    transition: all 0.2s ease;\r\n}\r\n\r\n.category-trigger {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 12px 16px;\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    text-align: left;\r\n    transition: background-color 0.2s ease;\r\n}\r\n\r\n.category-trigger:hover {\r\n    background: #f9fafb;\r\n}\r\n\r\n.category-info {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.category-icon {\r\n    font-size: 16px;\r\n}\r\n\r\n.category-title {\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    color: #1f2937;\r\n}\r\n\r\n.chevron {\r\n    width: 16px;\r\n    height: 16px;\r\n    color: #6b7280;\r\n    transition: transform 0.2s ease;\r\n}\r\n\r\n.chevron-up {\r\n    transform: rotate(180deg);\r\n}\r\n\r\n.chevron-down {\r\n    transform: rotate(0deg);\r\n}\r\n\r\n.category-content {\r\n    transition: all 0.2s ease;\r\n    overflow: hidden;\r\n}\r\n\r\n.content-closed {\r\n    max-height: 0;\r\n    opacity: 0;\r\n}\r\n\r\n.content-open {\r\n    opacity: 1;\r\n}\r\n\r\n.questions-list {\r\n    padding: 8px 12px 12px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 4px;\r\n    background: #fafbfc;\r\n}\r\n\r\n.question-button {\r\n    width: 100%;\r\n    text-align: left;\r\n    padding: 8px 12px;\r\n    background: #f0f2f5;\r\n    border: 1px solid transparent;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    font-size: 13px;\r\n    color: #374151;\r\n    line-height: 1.4;\r\n    transition: all 0.2s ease;\r\n}\r\n\r\n.question-button:hover {\r\n    background: #dbeafe;\r\n    border-color: #e5e7eb;\r\n    color: #1d4ed8;\r\n    transform: translateY(-1px);\r\n}\r\n\r\n.question-button:active {\r\n    transform: translateY(0);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
